import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DATE_FORMATS, formatStringDateToUI } from '@dealstack/shared/lib/format/dates/date';
import type { EmailTemplateSummaryRes } from '@dealstack/shared/lib/generated';

import type { TemplateVersion } from './useTemplateSummaryLabels.types';

export const useTemplateSummaryLabels = () => {
	const tMipManage = useTranslationMipManage();

	const versionLabel = (template: EmailTemplateSummaryRes): TemplateVersion => {
		if (!template.isCustomized || !template.updatedAt) {
			return {
				label: tMipManage('email_templates.list.version.dealstack_default', {
					defaultValue: 'Dealstack default',
				}),
			};
		}
		return {
			label: tMipManage('email_templates.list.version.updated', {
				defaultValue: 'Updated {{date}}',
				date: formatStringDateToUI(String(template.updatedAt), DATE_FORMATS.UI_SHORT),
			}),
			editor: template.updatedBy
				? tMipManage('email_templates.list.version.updated_by', {
						defaultValue: 'by {{name}}',
						name: template.updatedBy,
					})
				: undefined,
		};
	};

	const statusLabel = (template: EmailTemplateSummaryRes): string =>
		template.enabled
			? tMipManage('email_templates.status.active', { defaultValue: 'Active' })
			: tMipManage('email_templates.status.draft', { defaultValue: 'Draft' });

	return { versionLabel, statusLabel };
};
